import { ruPlural } from '@/lib/content/declension';

/**
 * UI-тексты виджетов экскурсий/туров:
 *   - TourCard (карточка тура без фото)
 *   - CityTours (секция «Экскурсии и туры» на странице города + фильтры)
 *   - PlacesListContent (список достопримечательностей + ledger-сравнение)
 *
 * Только вертикаль-специфика этих компонентов. Общие надзаголовки/якоря/теги
 * берутся из servicePage. Интерполируемые строки — функции; склонение/числа
 * считает компонент (Intl, ruPlural) и передаёт готовое значение.
 *
 * Строки квиза вида title/backToTours/loading/selectAtLeastOne приходят из
 * tourQuizData (translations[lang]) и сюда не переносятся.
 */
export const toursWidgetsUi = {
    en: {
        // ── TourCard ──
        card: {
            priceFrom: (value, symbol) => `from ${symbol}${value}`,
            durationHours: (h) => `${h}h`,
            durationMinutes: (m) => `${m}m`,
            reviews: 'reviews',
            inLang: 'in English',
            kidFriendly: 'Kid-friendly',
            view: 'View',
        },
        // ── CityTours ──
        cityTours: {
            eyebrow: (city) => `${city}. Tours`,
            title: 'Tours & activities',
            allLabel: 'All tours',
            lead: 'Tours and activities from trusted platforms — book directly with the operator.',
            all: 'All',
            group: 'Group',
            private: 'Private',
            kidFriendly: 'Kid-friendly',
            inLang: 'In English',
            reset: 'Reset',
            emptyTitle: 'Nothing matches the selected filters.',
            resetFilters: 'Reset filters',
            showMore: (n) => `Show ${n} more`,
        },
        // ── PlacesListContent ──
        places: {
            all: 'All',
            search: 'Search places…',
            searchAria: 'Search attractions',
            empty: 'Nothing found — try another query or type.',
            place: 'Place',
            type: 'Type',
            guide: 'Guide →',
            allTypes: 'All types',
            typesAria: 'Types',
            typeAria: 'Type',
            compareEyebrow: 'Compare',
            compareTitle: 'Compare places by type and city',
            allAttractionTypes: 'All attraction types',
            typeLabel: (label) => `Type: ${label}`,
            sortBy: (label) => `Sort by ${label}`,
            placePlural: (n) => (n === 1 ? 'place' : 'places'),
        },
    },
    ru: {
        // ── TourCard ──
        card: {
            priceFrom: (value, symbol) => `от ${value} ${symbol}`,
            durationHours: (h) => `${h} ч`,
            durationMinutes: (m) => `${m} мин`,
            reviews: 'отзывов',
            inLang: 'на русском',
            kidFriendly: 'Можно с детьми',
            view: 'Смотреть',
        },
        // ── CityTours ──
        cityTours: {
            eyebrow: (city) => `${city}. Экскурсии`,
            title: 'Экскурсии и туры',
            allLabel: 'Все экскурсии',
            lead: 'Экскурсии и активности от проверенных площадок — бронирование напрямую у организатора.',
            all: 'Все',
            group: 'Групповые',
            private: 'Индивидуальные',
            kidFriendly: 'Можно с детьми',
            inLang: 'На русском',
            reset: 'Сбросить',
            emptyTitle: 'Под выбранные фильтры ничего не подошло.',
            resetFilters: 'Сбросить фильтры',
            showMore: (n) => `Показать ещё ${n}`,
        },
        // ── PlacesListContent ──
        places: {
            all: 'Все',
            search: 'Поиск по местам…',
            searchAria: 'Поиск по достопримечательностям',
            empty: 'Ничего не найдено — измените запрос или тип.',
            place: 'Место',
            type: 'Тип',
            guide: 'Гайд →',
            allTypes: 'Все типы',
            typesAria: 'Типы',
            typeAria: 'Тип',
            compareEyebrow: 'Сравнение',
            compareTitle: 'Сравните места по типу и городу',
            allAttractionTypes: 'Все типы достопримечательностей',
            typeLabel: (label) => `Тип: ${label}`,
            sortBy: (label) => `Сортировать по: ${label}`,
            placePlural: (n) => ruPlural(n, ['место', 'места', 'мест']),
        },
    },
};
